import ozAppIncentive from './oz-app-incentive.vue'

export default ozAppIncentive
